import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-impersonate-info',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './impersonate-info.component.html',
  styleUrl: './impersonate-info.component.scss'
})
export class ImpersonateInfoComponent {
  @Input() userName!: string;
  @Input() userEmail!: string;
  @Output() backToProfile = new EventEmitter<void>();

  returnToProfile(): void {
    this.backToProfile.emit();
  }
}
